// src/actions/scheduleActions.js

import {
  GET_SCHEDULE_DATA_REQUEST,
  GET_SCHEDULE_DATA_SUCCESS,
  GET_SCHEDULE_DATA_FAILURE,
  SAVE_TEMPLATE_SLOT_SUCCESS,
  SAVE_TEMPLATE_SLOT_FAILURE,
  ADD_DAY_OFF_SUCCESS,
  ADD_DAY_OFF_FAILURE,
  ADD_BLOCKER_SUCCESS,
  ADD_BLOCKER_FAILURE,
  DELETE_SCHEDULE_ENTRY_SUCCESS,
  DELETE_SCHEDULE_ENTRY_FAILURE
} from './types';
import { baseURL } from './types';

/**
* ACTION 1: Fetches all schedule data from the API.
* This is the action that was causing your specific error.
*/
export const getScheduleData = (payload) => async (dispatch) => {
  const token = localStorage.getItem('token');
  dispatch({ type: GET_SCHEDULE_DATA_REQUEST });
  try {
    const response = await fetch(`${baseURL}/api/appointmentDoctorSchedule/getAll`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
      body: JSON.stringify(payload),
    });
    
    const responseData = await response.json();

    // THE FIX (Part 1): Handle both network errors and API-specific errors.
    // If the HTTP response is not 'ok' OR the API reports success: 0, treat it as a failure.
    if (!response.ok || responseData.success === 0) {
      console.error("API Error in getScheduleData:", responseData.message);
      dispatch({ type: GET_SCHEDULE_DATA_FAILURE, payload: responseData.message || "Failed to fetch schedule." });
      return; // Stop execution here. Do NOT throw.
    }
    
    dispatch({ 
      type: GET_SCHEDULE_DATA_SUCCESS, 
      payload: responseData.data 
    });
    return responseData.data;

  } catch (error) {
    console.error("Network Error in getScheduleData:", error);
    // THE FIX (Part 2): The catch block dispatches failure but does NOT re-throw the error.
    dispatch({ type: GET_SCHEDULE_DATA_FAILURE, payload: error.message });
  }
};

/**
* ACTION 2: Saves a new TEMPLATE slot.
* Corrected to no longer throw errors.
*/
export const saveTemplateSlot = (payload) => async (dispatch) => {
  const token = localStorage.getItem('token');
  try {
    const response = await fetch(`${baseURL}/api/appointmentDoctorSchedule/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
      body: JSON.stringify(payload),
    });
    const newSlot = await response.json();
    if (!response.ok || newSlot.success === 0) {
      dispatch({ type: SAVE_TEMPLATE_SLOT_FAILURE, payload: newSlot.message || "Failed to save slot." });
      return;
    }
    dispatch({ type: SAVE_TEMPLATE_SLOT_SUCCESS, payload: newSlot.data });
    return newSlot.data;
  } catch (error) {
    dispatch({ type: SAVE_TEMPLATE_SLOT_FAILURE, payload: error.message });
  }
};

/**
* ACTION 3: Adds a DAY OFF.
* Corrected to no longer throw errors.
*/
export const addDayOff = (payload) => async (dispatch) => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${baseURL}/api/appointmentDoctorSchedule/create`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
            body: JSON.stringify(payload)
        });
        const dayOffMarker = await response.json();
        if (!response.ok || dayOffMarker.success === 0) {
            dispatch({ type: ADD_DAY_OFF_FAILURE, payload: dayOffMarker.message || "Failed to add day off." });
            return;
        }
        dispatch({ type: ADD_DAY_OFF_SUCCESS, payload: dayOffMarker.data });
        return dayOffMarker.data;
    } catch (error) {
        dispatch({ type: ADD_DAY_OFF_FAILURE, payload: error.message });
    }
};

/**
* ACTION 4: Adds a BLOCKER.
* Corrected to no longer throw errors.
*/
export const addBlockerSlot = (payload) => async (dispatch) => {
  const token = localStorage.getItem('token');
  try {
      const response = await fetch(`${baseURL}/api/appointmentDoctorSchedule/create`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
          body: JSON.stringify(payload)
      });
      const newBlocker = await response.json();
      if (!response.ok || newBlocker.success === 0) {
          dispatch({ type: ADD_BLOCKER_FAILURE, payload: newBlocker.message || "Failed to add blocker." });
          return;
      }
      dispatch({ type: ADD_BLOCKER_SUCCESS, payload: newBlocker.data });
      return newBlocker.data;
  } catch (error) {
      dispatch({ type: ADD_BLOCKER_FAILURE, payload: error.message });
  }
};

/**
* ACTION 5: Deletes ANY schedule entry.
* Corrected to no longer throw errors.
*/
export const deleteScheduleEntry = (payload) => async (dispatch) => {
  const token = localStorage.getItem('token');
  try {
    const response = await fetch(`${baseURL}/api/appointmentDoctorSchedule/delete`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
      body: JSON.stringify({ id: payload.id }),
    });
    // For delete, we might just check for a successful status code.
    if (!response.ok) {
        const errorData = await response.json();
        dispatch({ type: DELETE_SCHEDULE_ENTRY_FAILURE, payload: errorData.message || "Failed to delete entry." });
        return;
    }
    dispatch({ type: DELETE_SCHEDULE_ENTRY_SUCCESS, payload: { id: payload.id } });
    return { id: payload.id };
  } catch (error) {
    dispatch({ type: DELETE_SCHEDULE_ENTRY_FAILURE, payload: error.message });
  }
};